import { EmployeeAccessTypeOption } from '@app/areas/admin/submodules/employees/models';
import { DeviceAdmin, FullAdmin, LocationAdmin } from '@shared/utils';

export const FullAdminOption: EmployeeAccessTypeOption = {
  key: 'full-admin',
  name: 'Full Admin',
  value: FullAdmin,
};

export const LocationAdminOption: EmployeeAccessTypeOption = {
  key: 'location-admin',
  name: 'Location Admin',
  value: LocationAdmin,
};

export const DeviceAdminOption: EmployeeAccessTypeOption = {
  key: 'device-admin',
  name: 'Device Admin',
  value: DeviceAdmin,
};

export const EmployeeAccessTypeOptions: EmployeeAccessTypeOption[] = [
  DeviceAdminOption,
  LocationAdminOption,
  FullAdminOption,
];
